import React, { useState } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import PerfectScrollbar from 'react-perfect-scrollbar'
import moment from 'moment'
import 'moment/locale/id'
import { makeStyles } from '@material-ui/styles'
import {
  Card,
  CardActions,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core'

import { getGrade, numberFormat, dateFormat, numberFormatTotal } from 'helpers'
import { ExModalDetail, ExModalFinish } from '../ExModal'

import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck'
import CheckIcon from '@material-ui/icons/Check'
import MenuOpenIcon from '@material-ui/icons/MenuOpen'
import EditIcon from '@material-ui/icons/Edit'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  content: {
    padding: 0,
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch'
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  actions: {
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      overflowX: 'auto'
    }
  },
  updateButton: {
    marginRight: theme.spacing(1)
  },
  imageContainer: {
    height: 96,
    width: 96,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '5px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  image: {
    width: '100%'
  },
  discountContainer: {
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
  chip: {
    display: 'flex',
    alignItems: 'center'
  },
  spacer: {
    flexGrow: 1
  }
}))

const ExTable = props => {
  const {
    className,
    transactions,
    page,
    pages,
    limit,
    onChangePage,
    onChangeRowsPerPage,
    onFinishData,
    onRejectData,
    onEditOrderData,
    ...rest
  } = props
  const classes = useStyles()

  const [selectedId, setSelectedId] = useState(0)
  const [modalDetail, setModalDetail] = useState(false)
  const [modalFinish, setModalFinish] = useState(false)
  const [detailData, setDetailData] = useState(null)
  const [isEditMode, setIsEditMode] = useState(false)

  const [anchorEl, setAnchorEl] = useState(null)
  const [menuTransaction, setMenuTransaction] = useState(null)

  const handleOpenMenu = (event, transaction) => {
    setAnchorEl(event.currentTarget)
    setMenuTransaction(transaction)
  }

  const handleCloseMenu = () => {
    setAnchorEl(null)
    setMenuTransaction(null)
  }

  const handleShowDetail = (item, isEdit = false) => {
    setDetailData(item)
    setIsEditMode(isEdit)
    setModalDetail(true)
  }

  const handleCloseDetail = () => {
    setModalDetail(false)
  }

  const handleShowFinish = (transactionId) => {
    setSelectedId(transactionId)
    setModalFinish(true)
  }

  const handleCloseFinish = () => {
    setModalFinish(false)
  }

  const handleOnFinish = () => {
    onFinishData(selectedId)
    setModalFinish(false)
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>No</TableCell>
                  <TableCell>Kode</TableCell>
                  <TableCell>Agen / Tipe / Jalur</TableCell>
                  <TableCell>Total Belanja</TableCell>
                  <TableCell>Total Diskon</TableCell>
                  <TableCell>Total Bayar</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Tanggal</TableCell>
                  <TableCell>Referral</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {transactions.map((transaction, index) => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={transaction.id}
                  >
                    <TableCell>{((page * limit) - limit) + (index + 1)}</TableCell>
                    <TableCell>{transaction.code}</TableCell>
                    <TableCell>
                      <div style={{ fontWeight: 600 }}>
                        {
                          (transaction.user)
                            ? `${transaction.user.name} - ${transaction.user.phone}`
                            : '-'
                        }
                      </div>
                      <div>
                        Tipe : {
                          (transaction.user)
                            ? getGrade(transaction.user.type)
                            : 'Eceran'
                        }
                      </div>
                      <div>Order : {transaction.main}</div>
                    </TableCell>
                    <TableCell>{numberFormat(transaction.total, 'Rp. ')}</TableCell>
                    <TableCell>
                      {
                        (transaction.voucher)
                          ? numberFormat(transaction.voucher?.value, 'Rp. ')
                          : '-'
                      }
                    </TableCell>
                    <TableCell>{numberFormatTotal(transaction.total, transaction.voucher, 'Rp. ')}</TableCell>
                    <TableCell>
                      <span
                        style={{
                          fontWeight: 700,
                          color:
                            transaction.status === 1
                              ? 'green'
                              : transaction.status === 2
                              ? 'red'
                              : 'inherit'
                        }}
                      >
                        {
                          (transaction.status === 0) ? 'Dalam Proses' :
                          (transaction.status === 1) ? 'Selesai' :
                          (transaction.status === 2) ? 'Ditolak' : '-'
                        }
                      </span>
                    </TableCell>
                    <TableCell>
                      <div>{moment(transaction.created_at).locale('id').format('dddd, D MMMM YYYY')}</div>
                      <div variant="caption" display="block" color="textSecondary">
                        Pukul {moment(transaction.created_at).locale('id').format('HH.mm')}
                      </div>
                    </TableCell>
                    <TableCell>
                      {
                        (() => {
                          const refUser = transaction.referral_user || (transaction.comission_histories && transaction.comission_histories[0] ? transaction.comission_histories[0] : null)
                          if (!refUser) return '-'

                          const name = refUser.name || refUser.user?.name || '-'
                          const code = refUser.referral || refUser.user?.referral || refUser.code || '-'
                          const comission = refUser.amount || refUser.comission || refUser.commission || 0

                          return (
                            <div>
                              <div variant="body2" style={{ fontWeight: 600 }}>{name}</div>
                              <div variant="caption" display="block" color="primary">{numberFormat(comission, 'Rp. ')}</div>
                            </div>
                          )
                        })()
                      }
                    </TableCell>
                    <TableCell>
                      <IconButton
                        color="inherit"
                        onClick={(e) => handleOpenMenu(e, transaction)}
                      >
                        <MoreVertIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>

        <Menu
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleCloseMenu}
        >
          {menuTransaction && menuTransaction.status === 0 && (
            <MenuItem
              onClick={() => {
                handleShowDetail(menuTransaction, true)
                handleCloseMenu()
              }}
            >
              <ListItemIcon style={{ minWidth: 36 }}>
                <EditIcon fontSize="small" color="primary" />
              </ListItemIcon>
              <ListItemText primary="Edit" />
            </MenuItem>
          )}
          {menuTransaction && (menuTransaction.status === 0 ? (
            <MenuItem
              onClick={() => {
                handleShowFinish(menuTransaction.id)
                handleCloseMenu()
              }}
            >
              <ListItemIcon style={{ minWidth: 36 }}>
                <CheckIcon fontSize="small" color="primary" />
              </ListItemIcon>
              <ListItemText primary="Selesaikan" />
            </MenuItem>
          ) : (
            <MenuItem disabled>
              <ListItemIcon style={{ minWidth: 36 }}>
                {menuTransaction && menuTransaction.status === 2 ? (
                  <CloseIcon fontSize="small" />
                ) : (
                  <PlaylistAddCheckIcon fontSize="small" />
                )}
              </ListItemIcon>
              <ListItemText primary={menuTransaction && menuTransaction.status === 2 ? 'Ditolak' : 'Selesai'} />
            </MenuItem>
          ))}
          {menuTransaction && menuTransaction.status === 0 && (
            <MenuItem
              onClick={() => {
                if (onRejectData) onRejectData(menuTransaction.id)
                handleCloseMenu()
              }}
            >
              <ListItemIcon style={{ minWidth: 36 }}>
                <CloseIcon fontSize="small" color="error" />
              </ListItemIcon>
              <ListItemText primary="Tolak" />
            </MenuItem>
          )}
          {menuTransaction && (
            <MenuItem
              onClick={() => {
                handleShowDetail(menuTransaction, false)
                handleCloseMenu()
              }}
            >
              <ListItemIcon style={{ minWidth: 36 }}>
                <MenuOpenIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Detail" />
            </MenuItem>
          )}
        </Menu>
      </CardContent>
      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={pages * limit}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
          page={page - 1}
          rowsPerPage={limit}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions>

      {
        (detailData)
          ? <ExModalDetail
            open={modalDetail}
            onClose={handleCloseDetail}
            transaction={detailData}
            isEdit={isEditMode}
            onSaveEdit={onEditOrderData}
          />
          : null
      }

      <ExModalFinish
        open={modalFinish}
        onClose={handleCloseFinish}
        onFinish={handleOnFinish}
      />
    </Card>
  )
}

ExTable.propTypes = {
  className: PropTypes.string,
  transactions: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  onChangeRowsPerPage: PropTypes.func.isRequired,
  onFinishData: PropTypes.func.isRequired,
  onRejectData: PropTypes.func,
  onEditOrderData: PropTypes.func
}

export default ExTable
